import {
  GetGorpReport,
  GorpReportData,
  GorpViewData,
  GorpViewDataRegional,
  ReportById,
  SearchResponse,
  Years,
  Countries,
} from "interfaces/dataInterfaces"
import { api } from "./api"

export const gorpApi = api.injectEndpoints({
  endpoints: builder => ({
    getGorps: builder.query<
      SearchResponse<GorpViewData>,
      { year: any; month?: any; countryCode?: string; regionCode?: string; skip: number; top: number }
    >({
      query: ({ year, month, countryCode, regionCode, skip, top }) => {
        let url = `Gorp/Get?skip=${skip}&top=${top}`
        if (year != null) {
          url = `${url}&year=${year}`
        }
        if (month != null) {
          url = `${url}&month=${month}`
        }
        if (countryCode != null) {
          url = `${url}&countryCode=${countryCode}`
        }
        if (regionCode != null) {
          url = `${url}&regionCode=${regionCode}`
        }
        return { url }
      },
      // transformResponse: (response: SearchResponse<GorpViewData>) => response.items,
      providesTags: [{ type: "Gorp" as const, id: "LIST" }],
    }),
    getGorpsByRegion: builder.query<
      SearchResponse<GorpViewDataRegional>,
      { year: any; month?: any; regionCode?: string; skip: number; top: number }
    >({
      query: ({ year, month, regionCode, skip, top }) => {
        let url = `Gorp/GetByRegion?skip=${skip}&top=${top}`
        if (year != null) {
          url = `${url}&year=${year}`
        }
        if (month != null) {
          url = `${url}&month=${month}`
        }
        if (regionCode != null) {
          url = `${url}&regionCode=${regionCode}`
        }
        return { url }
      },
      // transformResponse: (response: SearchResponse<GorpViewData>) => response.items,
      providesTags: [{ type: "Gorp" as const, id: "LIST" }],
    }),
    getGorpReports: builder.query<GetGorpReport[], { search?: string; skip: number; top: number }>({
      query: ({ skip, top }) => ({
        url: `Report/GetGorpReports?skip=${skip}&top=${top}&reportTypeId=3`,
      }),
      transformResponse: (response: any) => response.items,
      providesTags: [{ type: "GorpReports" as const, id: "LIST" }],
    }),
    getYears: builder.query<Array<Years>, void>({
      query: () => ({ url: "Gorp/GetYears" }),
      // transformResponse: (response: Array<Years>) => response.result,
      providesTags: (result = []) => [
        ...result.map(({ value }) => ({ type: "Gorp", value } as const)),
        { type: "Gorp" as const, id: "LIST" },
      ],
    }),
    getCountries: builder.query<Array<Countries>, void>({
      query: () => ({ url: "Gorp/GetCountries" }),
      // transformResponse: (response: Array<Years>) => response.result,
      providesTags: (result = []) => [
        ...result.map(({ value }) => ({ type: "Gorp", value } as const)),
        { type: "Gorp" as const, id: "LIST" },
      ],
    }),
    getGorpReportById: builder.query<ReportById, number>({
      query: id => ({
        url: `Report/gorp/${id}`,
      }),
    }),
    updateGorp: builder.mutation<void, Partial<GorpViewData>>({
      query: body => ({
        url: "Gorp/Put",
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "Gorp", id: "LIST" }],
    }),
    deleteGorp: builder.mutation<void, number>({
      query: id => ({
        url: `Gorp/Delete/?id=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Gorp", id: "LIST" }],
    }),
    postGorpReport: builder.mutation<any, { rid: number; file: FormData }>({
      query: ({ file, ...query }) => ({
        url: `Report/validateGorpReport`,
        method: "POST",
        params: query,
        body: file,
      }),
    }),
    validateReport: builder.mutation<any, GorpReportData[]>({
      query: body => ({
        url: `Gorp/ValidateData`,
        method: "POST",
        body,
      }),
    }),
    insertData: builder.mutation<any, { rid: number; values: GorpReportData[] }>({
      query: body => ({
        url: `Gorp/InsertData?rID=${body.rid}`,
        method: "POST",
        body: body.values,
      }),
      invalidatesTags: [
        { type: "GorpReports", id: "LIST" },
        { type: "Gorp", id: "LIST" },
      ],
    }),
  }),
})

export const {
  useGetGorpsQuery,
  useGetGorpsByRegionQuery,
  useGetYearsQuery,
  useGetCountriesQuery,
  useUpdateGorpMutation,
  useDeleteGorpMutation,
  usePostGorpReportMutation,
  useGetGorpReportByIdQuery,
  useValidateReportMutation,
  useInsertDataMutation,
  useGetGorpReportsQuery,
} = gorpApi
